import type {
  AriaController,
  AriaProps,
  RegisterAriaController,
} from '@wandb/forge-shell-contract/aria';
import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

const AriaContext = createContext<AriaProps>({controller: null});

export function AriaProvider({children}: {children: React.ReactNode}) {
  const [registration, setRegistration] = useState<{
    controller: AriaController;
  } | null>(null);
  const registerController = useCallback<RegisterAriaController>(controller => {
    const next = {controller};
    setRegistration(next);
    return () => {
      setRegistration(current => (current === next ? null : current));
    };
  }, []);

  const controller = registration?.controller ?? null;
  const value = useMemo(
    () => ({controller, registerController}),
    [controller, registerController]
  );

  return <AriaContext.Provider value={value}>{children}</AriaContext.Provider>;
}

export const useAriaContext = () => useContext(AriaContext);
